/**
 * 악덕 업체 상세 opener — 어디서든 마스터번호로 상세 표시.
 *
 * 사용:
 *   $j.F.Devil.Master.open(masterNum)      — 바텀시트(BS). 리스트 카드 클릭·앱 '악덕업체보기' 딥링크(devilMaster) 공용.
 *   $j.F.Devil.Master.openFull(masterNum)  — 풀페이지. 홈 알림상세 전용(뒤 배경 비침 제거).
 *
 * 렌더는 공용 $j.F.Devil.Render 에 위임 (List 카드 클릭·단독 페이지와 동일 구현).
 *
 * 세션이 끝난 뒤 누른 상세 — 상세 ajax 가 401 을 받으면 Network.setupAjax 가 /b/login 으로 보내
 * 자동로그인시키고 보던 화면으로 돌려보낸다. 그때 다시 누르지 않아도 되게 누른 업체를 기억했다가
 * (remember → 성공·다른 실패면 settle 이 지움) 돌아온 첫 화면에서 연다(resumePending, Sites/Devil/Bootstrap).
 */
const PENDING_KEY = 'b:master:pending';
const PENDING_TTL_MS = 10 * 60 * 1000;

const memberNo = () => (typeof MEMBER !== 'undefined' && MEMBER) ? (Number(MEMBER.num) || 0) : 0;

export default class Master {
    open = (masterNum) => {
        if (!masterNum) return;
        $j.Ui.BS.open({ target: $j.F.Devil.Render.masterTarget(masterNum), fixedHeight: true, backClose: true });
    }

    /** 상세 ajax 직전 — 세션이 끝나 로그인을 다녀와도 이어서 열 수 있게 누른 업체를 기억한다 */
    remember = (masterNum, full) => {
        $j.Common.Store.session.setJSON(PENDING_KEY, { num: masterNum, full: !!full, mb: memberNo(), at: Date.now() });
    }

    /** 상세를 받았거나 세션과 무관하게 실패했으면 잊는다. 401(세션 끝)이면 남긴다 — 로그인 뒤 이어서 연다 */
    settle = (jqXHR) => {
        if (!jqXHR || jqXHR.status !== 401) $j.Common.Store.session.remove(PENDING_KEY);
    }

    /** 로그인을 다녀온 첫 화면 — 기억해 둔 상세를 연다(같은 회원·10분 이내). 로그인 화면에서는 그대로 둔다 */
    resumePending = () => {
        const p = $j.Common.Store.session.getJSON(PENDING_KEY);
        const mb = memberNo();
        if (!p || !mb) return;
        $j.Common.Store.session.remove(PENDING_KEY);
        if (p.mb !== mb || !p.num || Date.now() - (p.at || 0) > PENDING_TTL_MS) return;
        p.full ? this.openFull(p.num) : this.open(p.num);
    }

    // 홈 알림상세 — 바텀시트가 아니라 불투명 풀페이지로. (dim 미처리로 뒤 내용이 비치던 문제 원천 해소)
    openFull = (masterNum) => {
        if (!masterNum) return;
        const R = $j.F.Devil.Render;
        const $page = $(`
            <div class="b-detailpage b-fade">
                <header class="b-detailpage__head">
                    <button type="button" class="b-detailpage__back" aria-label="뒤로">
                        <svg width="10" height="17" viewBox="0 0 10 18" fill="none"><path d="M9 1L1 9l8 8" stroke="var(--t1)" stroke-width="2.2" stroke-linecap="round"/></svg>
                    </button>
                    <span class="b-detailpage__title">업체 상세</span>
                </header>
                <div class="b-scroll b-noscroll b-detailpage__body">
                    <div class="b-detail"><p class="b-detail__loading">불러오는 중…</p></div>
                </div>
            </div>`);
        $('body').append($page);

        // 닫기: 히스토리 back → popstate → cleanup 단일 경로 (하드웨어 뒤로가기·헤더 ‹ 버튼 공통).
        let closed = false;
        const cleanup = () => {
            if (closed) return;
            closed = true;
            window.removeEventListener('popstate', onPop);
            $page.remove();
        };
        const onPop = () => cleanup();
        history.pushState({ bDetail: 1 }, '');
        window.addEventListener('popstate', onPop);
        $page.on('click', '.b-detailpage__back', () => history.back());

        const $detail = $page.find('.b-detail');
        this.remember(masterNum, true);
        $.getJSON('/b/ajax/master/' + masterNum)
            .done((res) => {
                this.settle();
                if (!res || !res.result) {
                    $detail.html(`<p class="b-detail__loading">${R.esc((res && res.message) || '불러오기 실패')}</p>`);
                    return;
                }
                $page.find('.b-detailpage__title').html(R.masterTitle(res.master || {}));
                R.renderMasterInto($detail, res);
            })
            .fail((jqXHR) => {
                this.settle(jqXHR);
                $detail.html('<p class="b-detail__loading">불러오기 실패</p>');
            });
    }
}
